import React, { useMemo } from "react";
import { useSelector } from 'react-redux';
import { RootState } from '@Redux/detail/store';
import { LightBox } from '@lion-design/core';
import styles from './styles.module.scss';
interface I_props {
    state: boolean;
    setState: Function;
}

function Contactlightbox(props: I_props) {
    const { state, setState } = props;
    const { GroupInfo } = useSelector((store: RootState) => store.groupReducer);
        // 跳轉頁面到連絡雄獅
    const contactURL = useMemo(()=>{
        const { GroupID, TourName } = GroupInfo;
        const url = window.location.href.includes("utravel") || window.location.href.includes("localhost") ? 
            'https://umember.liontravel.com/contact' : 'https://member.liontravel.com/contact';
        const obj = {
            ProductID: GroupID,
            ProductName: TourName,
            ProductURL: window.location.href,
        }
        const urlstring = new URLSearchParams(obj).toString();
        return url + `?${urlstring}`;
    },[GroupInfo])
    return (
        <LightBox
            open = {state}
            ToggleLightBox = {()=>{setState(false)}}
            className={styles.contactlightbox}
        >
            <div className={styles.content}>
                <div>
                    <span>此產品非台灣出發，</span>
                    <span>請留下您的資料將有人員為您服務</span>
                </div>
                <div>
                    <button onClick={()=>setState(false)}>留在原頁</button>
                    <a href={contactURL}>填寫資料</a>
                </div>
            </div>
        </LightBox>
    )
}

export default Contactlightbox;